import { useEffect, useRef, useState } from 'react'
import swal from "sweetalert";
import DeleteIcon from '@mui/icons-material/Delete';
import { AgGridReact } from "ag-grid-react";
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
import { Box, Button, Tooltip } from '@mui/material';
import { addNewUnitsEnumsFile } from '../api/unitsandenumsapi';
import { useDispatch, useSelector} from 'react-redux';
import { useNavigate } from 'react-router-dom';
import UnitsAndEnumsModal from './UnitsAndEnumsModal';
import { closeUnitsAndEnumsDialog, openUnitsAndEnumsDialog } from '../state/unitsandenums/actions';
ModuleRegistry.registerModules([ AllCommunityModule ]);

let tempId = 600000;

const UnitEnumsGrid = ({result}) => {

    const dispatch                          =   useDispatch();
    const gridRef                           =   useRef();
    const [columns,setColumns]              =   useState([]);
    const [rows, setRows]                   =   useState([]);
    //const [gridApi, setGridApi]             =   useState(null);
    const navigate                          =   useNavigate();
    const [formModalData, setFormModalData] = useState({
            releaseNotes:'',
            fileName: '',
            isLatest: false
    });
    const unitsAndEnumsDialogBoxStatus  = useSelector((state) => state.unitAndEnumData.isUnitsAndEnumsDialogOpen);

    useEffect(() => {
        const handleEditingFileContents = () => {
            if (result.length > 0) {
                const resultWithIds = result.map((row, index) => ({
                    id: index + 1,
                    ...row,
                    fromDB: true
                }));
    
                setRows(resultWithIds);
    
                const keys = Object.keys(result[0] || {});
                const generatedCols = keys.map((key) => ({
                    field: key,
                    headerName: key.charAt(0).toUpperCase() + key.slice(1),
                    width: 150,
                    editable: key === "Enumeration" ? false : true,
                    resizable: false,
                    sortable: false
                }));
    
                // add Actions column
                generatedCols.push({
                    field: "actions",
                    headerName: "Actions",
                    editable: false,
                    resizable: false,
                    sortable: false,
                    cellRenderer: (params) => {
                        if (!params.data.fromDB) {
                            return (
                                <Tooltip title="Delete">
                                    <DeleteIcon 
                                        onClick={() => handleDelete(params.data)} 
                                        color="error" 
                                        sx={{cursor:'pointer',mt:1}} 
                                        fontSize="small"
                                    />
                                </Tooltip>
                            );
                        }
                        return null;
                    }
                });
                setColumns(generatedCols);
            } else {
                setRows([]);
                setColumns([]);
            }
        }
        handleEditingFileContents();    
    },[result]);

    const handleAddRow = () => {
        if (!gridRef.current) return;
        const allRows = [];
        gridRef.current?.forEachNode((node) => allRows.push(node.data));

        const keys = columns
        .map((c) => c.field)
        .filter((f) => f !== "actions" && f !== "id" && f !== "fromDB");

        const lastEnumeration = allRows.length > 0 ? allRows[allRows.length - 1].Enumeration : 0;

        const newRow = keys.reduce(
        (acc, key) => ({ ...acc, [key]: key === "Enumeration" ? (parseInt(lastEnumeration) + 1).toString() : "" }),
        { uniqueId: tempId++, fromDB: false,id: allRows.length + 1}
        );
        
        gridRef.current?.applyTransaction({ add: [newRow] });
    };


    const handleDelete = (row) => {
        
        if (!gridRef.current) return;
        gridRef.current?.applyTransaction({ remove: [row] });

        const allRows = [];
        gridRef.current?.forEachNode((node) => allRows.push(node.data));
        const lastDbRow = [...allRows].reverse().find((r) => r.fromDB);
        const startEnumeration = lastDbRow ? lastDbRow.Enumeration : 0;
        let counter = parseInt(startEnumeration) + 1;
        //console.log('startLabelId',startEnumeration)
        allRows.forEach((r) => {
            if (!r.fromDB) {
                r.Enumeration = counter++;
            }
        });
        // console.log('allRows',allRows)
    };

    // Save new Data
    const handleSave = () => {
        if (!gridRef.current) return;
        if(formModalData.length === 0 || formModalData.fileName === '' || formModalData.releaseNotes === ''){
            swal("Oops!", "Please fill required fields!", "error");
            return false;
        }
        const allRows = [];
        gridRef.current?.forEachNode((node) => allRows.push(node.data));
        const payload  = allRows.map(({ id, fromDB,uniqueId,actions, ...rest }) => rest);
        const formData = new FormData(); 
        formData.append('fileContents', new Blob([JSON.stringify(payload)],{type:'application/json'}),'fileContent.txt');
        formData.append('fileName',formModalData.fileName)
        formData.append('releaseNotes',formModalData.releaseNotes);
        formData.append('isLatest',formModalData.isLatest);
        dispatch(addNewUnitsEnumsFile(formData));
        // if(unitsAndEnumsDialogBoxStatus === false) {
        //     dispatch(closeUnitsAndEnumsDialog());
        // }
        dispatch(closeUnitsAndEnumsDialog());
        handleGoBack();
    };
    
    const handleGoBack = () => {
        navigate('/web/units');
    };

    const handleClickOpenRole = () => {
        document.activeElement.blur(); 
        dispatch(openUnitsAndEnumsDialog());
    };

    return (
        <>
            <Box display="flex" justifyContent="space-between" alignItems="center" width="100%" sx={{paddingBottom:2}}>
                <Button onClick={handleGoBack} variant="contained">Back</Button>
                <Box display="flex" gap={2}> {/* Use gap for spacing between right buttons */}
                    <Button variant="contained" color="secondary" onClick={handleAddRow}> Add Row </Button>
                    <Button variant="contained" sx={{ ml: 2 }} onClick={handleClickOpenRole} > Create </Button>
                </Box>
            </Box>
            <div style={{  width: "100%", height: "500px" }}>
                <AgGridReact
                    stopEditingWhenCellsLoseFocus={true}
                    ref={gridRef}
                    rowData={rows}
                    columnDefs={columns}
                    animateRows={true}
                    suppressMovableColumns={true}
                    getRowId={(params) => params.data.uniqueId ?? params.data.id}
                    onGridReady={(params) => {
                       // setGridApi(params.api); 
                       gridRef.current = params.api;
                    }}
                />
            </div>
            <UnitsAndEnumsModal 
                title={"Units New File"}
                open={unitsAndEnumsDialogBoxStatus || false}
                value={formModalData}
                setFormModalData={setFormModalData}
                handleSave={handleSave}
            />
        </>
    )
}

export default UnitEnumsGrid